<script setup lang="ts">
import { CHANGE_KIND_LABELS, type ChangeKindName } from '@cockpit/shared';

/** Lot BA : lignes d'une ou plusieurs versions rangées par écran, avec l'étiquette Nouveau / Amélioré / Corrigé. */
defineProps<{
  screens: readonly { screen: string; changes: readonly { kind: ChangeKindName; text: string }[] }[];
  /** Niveau du titre de chaque écran (h3 sur la page, h4 dans le popup). */
  headingLevel?: 3 | 4;
}>();
</script>

<template>
  <div class="nv-screens">
    <div v-for="group in screens" :key="group.screen" class="nv-screen" :data-screen="group.screen">
      <component :is="`h${headingLevel ?? 4}`">{{ group.screen }}</component>
      <ul>
        <li v-for="(change, i) in group.changes" :key="i">
          <span class="nv-kind" :class="`nv-kind-${change.kind}`">{{ CHANGE_KIND_LABELS[change.kind] }}</span>
          <span>{{ change.text }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
